import React from 'react';
import { connect, ConnectedProps } from '@cerebral/react';
import { state } from 'app/pwa/app.cerebral';
import { Wrapper, ActivityIcon } from './elements';
import { OverlapIcons } from 'dc/OverlapIcons';
import { useGetActivityIconUrl } from 'common/hooks';

type Props = {
  readonly expanded?: boolean;
  readonly eventActivities: string[];
  readonly onClick?: () => void;
};

const deps = {
  activities: state.appContainer.activities,
};

export function ASB001({
  expanded,
  eventActivities,
  activities,
  onClick,
}: Props & typeof deps & ConnectedProps): React.ReactElement {
  const getActivityIconUrl = useGetActivityIconUrl();
  const iconUrls = eventActivities.map(activityKey =>
    getActivityIconUrl(activities[activityKey]?.icon)
  );

  return (
    <Wrapper $expanded={expanded} onClick={onClick}>
      <OverlapIcons
        iconUrls={iconUrls}
        expanded={expanded}
        render={(iconUrl, iconPosition) => (
          <ActivityIcon icon={iconUrl} key={iconUrl} $position={iconPosition} />
        )}
      />
    </Wrapper>
  );
}

export default connect<Props, typeof deps>(deps, ASB001);
